<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<div class="container">
					<div class="row">
						<div class="col-6">
							<img src="assets/images/nmi_logo.webp" alt="NMI Logo" height="50px">
							<h1>Billing Module</h1>
						</div>
						<div class="col-6" align="right">
							<button class="btn btn-danger" *ngIf="!showPayed" (click)="showPayed = true">View paid leads</button>
							<button class="btn btn-danger" *ngIf="showPayed" (click)="showPayed = false">View unpaid leads</button>
						</div>
					</div>
				</div>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<div class="container">
					<div class="col-12" align="top" *ngIf="loading">
						<app-loading></app-loading>
					</div>
				</div>
				<br>

				<div class="container" *ngIf="!showPayed">
					<div class="row" *ngIf="!loading">
						<div class="col-12">
							<app-not-payed-leads [payment_provider]="'NMI'"></app-not-payed-leads>
						</div>
					</div>
				</div>

				<div class="container" *ngIf="showPayed">
					<div class="row" *ngIf="!loading">
						<div class="col-12">
							<app-payed-leads></app-payed-leads>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>





